import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AllergiesState, AllergyApiResponse } from "./index.types";

export const initialAllergiesState: AllergiesState = {
  allergiesData: [],
  allergiesIsLoading: false,
};

const name = "allergies";

export const allergiesSlice = createSlice({
  name,
  initialState: initialAllergiesState,
  reducers: {
    getAllergies: (state) => {
      state.allergiesIsLoading = true;
    },
    getAllergiesSuccess: (state, action: PayloadAction<AllergyApiResponse>) => {
      state.allergiesIsLoading = false;
      state.allergiesData = action.payload?.results;
    },
    getAllergiesFail: (state) => {
      state.allergiesData = [];
      state.allergiesIsLoading = false;
    },
    clearAllergiesData: (state) => {
      state.allergiesData = [];
      state.allergiesIsLoading = false;
    },
  },
});

export const { getAllergies, clearAllergiesData } = allergiesSlice.actions;

export default allergiesSlice.reducer;

export const getAllergiesByPatientId = (patientId: string) => ({
  payload: {
    apiName: name,
    method: "get",
    url: `/api/patients/${patientId}/allergies/`,
  },
  type: "getAllergies",
});
